import React from 'react'
import { useState } from 'react'
import Projects from '../assets/projects.json'

const Slideshow = () => {
    const [project, setProject] = useState(1)
    const prj = Projects.projects[project]


    const next = () => {
        if (project > 5) {
            console.log(project)

            setProject(0);
        }
        console.log(project)

        setProject(project => project + 1)

    }

    const prev = () => {
        if (project <= 1) {
            setProject(5);
        }
        setProject(project => project - 1)
    }


  return (
    <div name="portfolio" className='bg-gradient-to-b from-black to-gray-800 w-full text-white md:h-screen'>
        <div className='max-w-screen-lg p-4 mx-auto flex flex-col w-full h-full'>

            <div className='pb-8'>
                <p className='md:flex text-4xl tracking-wide font-bold inline border-gray-500'>Portfolio</p>
            </div>
            {/* Modify this for the img AND  text*/}
            <div className=' justify-between md:flex md:mt-32 px-auto'>
                <div className=' align-middle flex-col rounded-md md:flex justify-between md:w-1/2'>
                    <div className='top-0'>
                    <b className='text-lg underline'>{prj.title}</b>                     
                    <p className='text-slate-300'>Months into the Program: {prj.term}</p>
                    </div>
                    
                    <p>

                    {prj.body}</p>

                    <p>
                        Technologies:
                            <li>{prj.technologies}</li>
                    </p>
                    <div className='text-right'>
                    <button onClick={prev} className="text-center mr-2 justify-end px-6 py-2 w-20 rounded-md 
                    bg-slate-500">Prev</button>
                        <button onClick={next} className="text-center justify-end px-6 py-2 w-20 rounded-md 
                    bg-slate-500"> {'Next'}</button>
                        {/*  text-white w-fit mx-2 px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r 
                    bg-white cursor-pointer */}

                    </div>

                </div>
                

            {/* img */}
            <div className='w-full md:flex md:w-2/3 justify-center '>
            {/* <motion.div className="introduction"
            initial={{opacity: 0, y: -150}} 
            animate={{opacity: 1, y: -10}} 
            transition={{delay: 0.7, type:"spring", stiffness: 500 ,duration:0.5}}> */}

                <img className='transition-all py-1 w-full md:flex md:w-1/2' src={prj.image} alt=""/>
            {/* </motion.div> */}

            </div>
            </div>


        </div>
    </div>

  )
}

export default Slideshow;